import React, { useState } from 'react';
import { useMetaMask } from '../../../../hooks/useMetaMask';
import styles from './metamask-button.module.scss';


interface MetaMaskButtonProps {
  account: string | null;
  connectWallet: () => void;
  disconnectWallet: () => void;
}

export const MetaMaskButton: React.FC<MetaMaskButtonProps> = ({ account, connectWallet, disconnectWallet }) => {


  if (account) return null;

  const handleButtonClick = () => {

    connectWallet();

  };

  if (account) return null;

  return (
    <div>
      <button
        onClick={handleButtonClick}
        type="button"
        className={`${styles.metamaskButton} qc-header-wallet-btn`}
      >
        <span className={styles.accountText}>
          Connect Wallet
        </span>
      </button>
    </div>
  );
};
